import Image from 'next-export-optimize-images/image'

type Props = {
  author: string
  img: string
  when: string
}

const AuthorWrittenBy = ({ author, img, when }: Props) => {
  return (
    <div className="flex flex-row items-center">
      <Image
        src={img}
        width={48}
        height={48}
        alt={author}
        className="object-cover w-12 h-12 mr-5 rounded-full"
      />
      <div>
        <span>Written by </span>
        <span className="text-blue">{author}</span>
        <span>.</span>
        <span className="block lg:inline lg:ml-2">{when}</span>
      </div>
    </div>
  )
}

export default AuthorWrittenBy
